import { render, staticRenderFns } from "./BlockPopupFaq.vue?vue&type=template&id=4dbf5312&scoped=true&"
import script from "./BlockPopupFaq.vue?vue&type=script&lang=ts&"
export * from "./BlockPopupFaq.vue?vue&type=script&lang=ts&"
import style0 from "./BlockPopupFaq.vue?vue&type=style&index=0&id=4dbf5312&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf5312",
  null
  
)

export default component.exports